<ng-container [formGroup]="priceModel">
  <mat-form-field libZalamoField *libIsUserTester="'CountryPricePicker'">
    <mat-select formControlName="country">
      <mat-option value="PL">Polska</mat-option>
      <mat-option value="DE">Niemcy</mat-option>
      <mat-option value="FR">Francja</mat-option>
      <mat-option value="USA">USA</mat-option>
    </mat-select>
    <lib-zalamo-field-decoration></lib-zalamo-field-decoration
  ></mat-form-field>
  <mat-form-field
    libZalamoField
    [explainer]="explainer"
    [noBottomMargin]="true"
  >
    <mat-label>
      <ng-content></ng-content>
    </mat-label>
    <input
      (focus)="onFocused.emit()"
      (keydown)="filterKeys($event)"
      (wheel)="disableScroll($event)"
      formControlName="price"
      matInput
      min="0"
      step="1"
      type="number" />
    <lib-currency-picker
      (focused)="onFocused.emit()"
      formControlName="code"
      matSuffix
    ></lib-currency-picker>
    <lib-zalamo-field-decoration></lib-zalamo-field-decoration
  ></mat-form-field>
</ng-container>
@if (currentValue.length > 1) {
  <lib-button icon-only (click)="openPreview()" [matBadge]="currentValue.length"
    ><mat-icon>list</mat-icon></lib-button
  >
}
<ng-template #preview>
  <div class="preview">
    <mat-dialog-content>
      @for (price of currentValue; track price; let i = $index) {
        <div class="price">
          {{ price.price | currency: price.code }}
          <lib-button confirm icon-only (clicked)="removePrice(i)"
            ><mat-icon>delete</mat-icon></lib-button
          >
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      <lib-button (click)="closePreview$.next()">Zamknij</lib-button>
    </mat-dialog-actions>
  </div>
</ng-template>
